import {requestData} from 'services'
import {UserBannedStatus} from 'types'
import {GIFT_SHOP_CACHE_TTL_MS} from 'consts'
import {reduxSelector, reduxUpdateDispatcher} from 'lib/redux'

let lastFetch = 0
let activeFetchPromise: Promise<UserBannedStatus | null> | null = null

function getMapReduxCache(): Omit<UserBannedStatus, 'id' | 'member_id'> | null {
  const state = reduxSelector('userBanStatus')
  return {
    is_sell_allowed: state.is_sell_allowed,
  }
}

function isCacheValid() {
  const {is_sell_allowed} = reduxSelector('userBanStatus')
  const isCacheExpired = Date.now() - lastFetch > GIFT_SHOP_CACHE_TTL_MS
  const isDataMissing = is_sell_allowed === undefined

  return !isCacheExpired && !isDataMissing
}

async function fetchData(): Promise<UserBannedStatus | null> {
  try {
    const response = await requestData('giftshop_get_account_status')

    if (typeof response !== 'string' && response.status === 200) {
      lastFetch = Date.now()
      const {result} = response.data

      reduxUpdateDispatcher('userBanStatus', {
        is_sell_allowed: result.is_sell_allowed,
      })
      return {
        is_sell_allowed: result.is_sell_allowed,
      }
    }
  } catch (e) {
    console.error(e)
  } finally {
    activeFetchPromise = null
  }

  return getMapReduxCache()
}

export async function handleGiftshopGetSellBanStatus(
  forceRequest = false,
): Promise<UserBannedStatus | null> {
  if (activeFetchPromise) return activeFetchPromise

  if (forceRequest || !isCacheValid()) {
    activeFetchPromise = fetchData()

    return activeFetchPromise
  }

  return getMapReduxCache()
}
